import { render, staticRenderFns } from "./RedeemConfirm.vue?vue&type=template&id=46885918&"
import script from "./RedeemConfirm.vue?vue&type=script&lang=js&"
export * from "./RedeemConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports